import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import { formatPatientName } from '../../helpers/patients';
import { getPatientStatusOptions } from '../patients/PatientStatusFilter';
import NewSessionButton from '../sessions/NewSessionButton';

const UnscheduledPatientsPanel = ({ patients = [], boxStyles }) => {
  const navigate = useNavigate();
  const { Icon, color } = getPatientStatusOptions('unscheduled');
  return (
    <Box sx={{ ...boxStyles, p: 2 }}>
      <Typography variant='h2'>Unscheduled</Typography>
      <Stack spacing={2} pt={2.5} sx={{ maxHeight: 300, overflowY: 'auto' }}>
        {
          patients.length
          ? patients.map(patient => (
            <Stack
              key={patient.id}
              direction='row'
              alignItems='center'
              justifyContent='space-between'
            >
              <Stack
                direction='row'
                spacing={1}
                alignItems='center'
                sx={{ minWidth: 0, cursor: 'pointer' }}
                onClick={() => navigate(`/providers/patients/view/${patient.id}`)}
              >
                <Icon style={{ color, fontSize: '0.75rem', flexShrink: 0 }} />
                <Typography
                  variant='body1'
                  noWrap
                  style={{ color: config().colors.primary }}
                >
                  {formatPatientName(patient)}
                </Typography>
              </Stack>
              <NewSessionButton 
                sessionVersion='2' 
                iconOnly 
                defaultPatientId={patient.id}
              />
            </Stack>
          ))
          : <Typography variant='body1' color='text.gray'>No unscheduled patients</Typography>
        }
      </Stack>
    </Box>
  );
};

export default UnscheduledPatientsPanel;
